import type { ImageControlsStyles } from "../../types";
import type { SxProps, Theme } from "@mui/material";

const getStyles = (): Record<ImageControlsStyles, SxProps<Theme>> => {
  return {
    root: {
      position: "absolute",
      right: "10px",
      top: "10x",
      userSelect: "none",
      bgcolor: "#fff",
      boxShadow: "0px 2px 6px rgba(53, 67, 93, 0.32)",
      zIndex: 1,
      // border: "solid violet 1px"
    },

    button: {
      textAlign: "center",
      cursor: "pointer",
      height: "30px",
      width: "30px",
      borderBottom: "1px solid #ccc",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },

    viewer: {
      // width: "80%",
      // height: "80%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      // border: "solid red 1px"
    },
  };
};

export default getStyles;
